import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const RideTabsStationsPanelStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-tabs-station-panel",
})``;
